
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'

class PriceListHelper {

    static getStatusName(intl, status) {
        switch (status) {
            case 'draft':
                return intl.formatMessage({
                    id: "price_list.status.draft_label",
                    defaultMessage: "Draft",
                })
            case 'active':
                return intl.formatMessage({
                    id: "price_list.status.active_label",
                    defaultMessage: "Active",
                })
            case 'inactive':
                return intl.formatMessage({
                    id: "price_list.status.inactive_label",
                    defaultMessage: "Inactive",
                })
        }
    }

}

export default injectIntl(PriceListHelper)


// WEBPACK FOOTER //
// ./src/price-list/pricelisthelper.jsx